import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { theme } from '../theme';
export const Divider = memo(function Divider({ maxWidth = 'none', height = '1px', color = 'oatmeal', ...marginProps }) {
    return (React.createElement(Line, { "$maxWidth": maxWidth, "$height": height, "$color": color, ...marginProps }));
});
const Line = styled(Box) `
  ${({ $color }) => $color &&
    css `
      background: ${theme.colors[$color]};
    `}
  display: block;
  height: ${({ $height }) => $height};
  max-width: ${({ $maxWidth }) => $maxWidth};
  width: 100%;
`;
//# sourceMappingURL=Divider.js.map